import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { handleError } from 'src/app/sdc/utils/error.handler';
import { LoginModal } from '../models/login.model';
import { UserDetailsModel, UserDetailsV2Model } from '../models/userdetails.model';
import { OtpdataModel } from '../models/otpdata.model';
import { api_url } from '../utils/constants.helper';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class LoginService {
  apigee_url: string;

  private loginRedirectSubject: BehaviorSubject<boolean> = new BehaviorSubject(false);

  isLoginRedirect: Observable<boolean> = this.loginRedirectSubject.asObservable();

  private tokenExpiredMessageSubject: BehaviorSubject<string | null> = new BehaviorSubject<string | null>(null);

  tokenExpiredMessage: Observable<string | null> = this.tokenExpiredMessageSubject.asObservable();

  private validatedUserDetailsSubject: BehaviorSubject<UserDetailsModel | UserDetailsV2Model | null> = new BehaviorSubject<UserDetailsModel | UserDetailsV2Model | null>(null);

  validatedUserDetails: Observable<UserDetailsModel | UserDetailsV2Model | null> = this.validatedUserDetailsSubject.asObservable();

  private otpServiceDataSubject: BehaviorSubject<OtpdataModel | null> = new BehaviorSubject<OtpdataModel | null>(null);

  otpServiceData: Observable<OtpdataModel | null> = this.otpServiceDataSubject.asObservable();

  constructor(private httpClient: HttpClient) {
    this.apigee_url = environment.apigee_sdc_base_url;
  }

  updateOtpServiceData(data: OtpdataModel): void {
    this.otpServiceDataSubject.next(data);
  }

  updateRedirectionCheck(message: string): void {
    this.loginRedirectSubject.next(true);
    this.tokenExpiredMessageSubject.next(message);
  }

  decryptUserDetails(reference: string): Observable<{ employeeId: string; sdcCardNo: string }> {
    return this.httpClient
      .get<{ data: { employeeId: string; sdcCardNo: string } }>(`${this.apigee_url}${api_url.DECRYPT_USER}${reference}`)
      .pipe(
        map((response) => response.data),
        catchError((e) => throwError(() => handleError(e).message))
      );
  }

  validate(loginModal: LoginModal): Observable<UserDetailsModel> {
    return this.httpClient
      .post<{ data: UserDetailsModel }>(`${this.apigee_url}${api_url.VALIDATION}`, loginModal)
      .pipe(
        map((response) => {
          this.validatedUserDetailsSubject.next(response.data);
          this.loginRedirectSubject.next(false);
          return response.data;
        }),
        catchError((e) => throwError(() => handleError(e).message))
      );
  }
}
